export const soundTimeline = [
    {
        name: 'inStart',
        startTime: 0,
        volume: 0.5,
    },
    {
        name: 'slash',
        startTime: 1500,
        volume: 0.7,
    },
    {
        name: 'dramatic',
        startTime: 1700,
        volume: 0.5,
    },
    {
        name: 'reveal',
        startTime: 3000,
        volume: 0.5,
    },
    {
        name: 'angry',
        startTime: 4300,
        volume: 0.5,
    },
    {
        name: 'outStart',
        startTime: 9000,
        volume: 0.3,
    },
];
